import React from 'react';
import { useVendorAgreementsTableCols } from '../hooks/VendorCols';
import DashboardAthenaTable from './DashboardAthenaTable';

export default function VendorAgreementsTable(props) {
const { type = 'ap' } = props;
  const vendorAgreementsCols = useVendorAgreementsTableCols();

  const queryName = getQueryName(type);

  const transformData = (data) => {
    return data.map((item) => {
      return {
        ...item,
        AGREEMENT_LINK: <span className='editLink' onClick={() => {
          const win = window.open(
            `/vendor-agreement?procureGroup=${item.PROCURE_GROUP}&agreementType=${item.TYPE}&agreementRef=${item.VEN_AGRMT_REF}`,
            '_blank'
          )
          win.focus()
        }}>{item.VEN_AGRMT_REF}</span>
      }
    })
  }
  return (
    <>
        <DashboardAthenaTable
            {...props}
            params={{ ...props.headers }}
            tableColumns={vendorAgreementsCols}
            reportParamName={queryName}
            reportName={queryName}
            tableTitle={''}
            transform={transformData}
            callback={()=>{}}
            downloadFileName={`${type.toUpperCase()}_Agreements_Download`}
        />
    </>
  );
}


const getQueryName = (type) => {
    if (type === 'ap') {
    return 'ap_vendor_agreements';
    } else if (type === 'item') {
    return 'item_vendor_agreements';
    }
}
